import React from "react";
import { Modal } from "@mantine/core";

import ModalHeader from "components/ModalHeader";
import AddHolidayForm from "./addHolidayForm";

type AddClientModalProps = {
  opened: boolean;
  onClose: () => void;
};

function AddHolidayModal({ opened, onClose }: AddClientModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Add Holiday"
        onClose={onClose}
        ariaLabel="Close add Holiday modal"
      />
      <AddHolidayForm onClose={onClose} />
    </Modal>
  );
}

export default AddHolidayModal;
